import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1c33d55c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=1c33d55c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c33d55c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c33d55c')) {
      api.createRecord('1c33d55c', component.options)
    } else {
      api.reload('1c33d55c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=1c33d55c&scoped=true&", function () {
      api.rerender('1c33d55c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tpmRoutePatrol/detail.vue"
export default component.exports